import React, { useState, memo, useImperativeHandle, forwardRef } from 'react';
import { Checkbox, Input } from 'appkit-react';
import { Col } from 'antd';

const MultipleSelection = (props, ref) => {
  const { values = {}, options = [], cols = 1 } = props;

  // console.log(ref);

  const [indexes, setIndexes] = useState(
    Array.isArray(values.choices)
      ? values.choices.map((v) => parseInt(v, 10) - 1)
      : [],
  );
  const [inputValue, setInputValue] = useState(values.other || '');

  useImperativeHandle(ref, () => ({
    getValues: () => ({
      choices:
        Array.isArray(indexes) &&
        indexes.map((i) => String(parseInt(i, 10) + 1)),
      other: inputValue,
    }),
  }));

  if (!Array.isArray(options)) {
    return <div />;
  }

  const getIndex = (option) => options.findIndex((o) => o.text === option.text);
  const exclusiveOptionIndex = options.findIndex((o) => o.isExclusive);
  const isChecked = (v) => Array.isArray(indexes) && indexes.includes(v);

  const handleEachChange = (option) => (_) => {
    const thisIndex = getIndex(option);
    if (isChecked(thisIndex)) {
      if (option?.hasSupplement) {
        setInputValue('');
      }
      setIndexes(
        Array.prototype.concat(
          [],
          indexes.filter((idx) => idx !== thisIndex),
        ),
      );
      return;
    }
    if (option.isExclusive) {
      setIndexes([thisIndex]);
      return;
    }
    setIndexes([
      ...indexes.filter((idx) => idx !== exclusiveOptionIndex),
      thisIndex,
    ]);
  };

  return (
    <>
      {options.map((o, i) => (
        <Col key={i} span={24 / cols} className="selection-col">
          <Checkbox
            className="checkbox"
            key={i}
            value={o.text}
            checked={isChecked(getIndex(o))}
            onChange={handleEachChange(o)}
          >
            {o.text}
          </Checkbox>
          {o.hasSupplement ? (
            <Input
              className="checkbox-input"
              value={inputValue}
              disabled={Array.isArray(indexes) && !indexes.includes(i)}
              onChange={setInputValue}
            />
          ) : null}
        </Col>
      ))}
    </>
  );
};

export default memo(forwardRef(MultipleSelection));
